import { render } from "./StorePerformance.vue?vue&type=template&id=080d8390&scoped=true"
import script from "./StorePerformance.vue?vue&type=script&lang=js"
export * from "./StorePerformance.vue?vue&type=script&lang=js"

import "./StorePerformance.vue?vue&type=style&index=0&id=080d8390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080d8390"]])

export default __exports__